window.addEventListener('load', () => {
    const copyTextElements = document.querySelectorAll('.js-copy-text')
    for (const el of copyTextElements) {
        el.addEventListener('command', (event) => {
            if (event.command === '--copy-text') {
                navigator.clipboard.writeText(el.innerText)
                el.classList.add('js-copy-text--copied')
                setTimeout(() => {
                    el.classList.remove('js-copy-text--copied')
                }, 3000)
            }
        })
    }
})